// 🔧 scoring_step.js
// ✅ Purpose: Experience Factory scoring-configuration pipeline step
// ✅ Features:
// - Executes the reusable Scoring Builder
// - Supports Experiences that opt into scoring through their manifest
// - Safely no-ops for existing Experiences without scoring configuration
// - Runs before Entry/User/Vote generation
// - Stores scoring result metadata in DemoContext
// - Uses standardized pipeline success results
// - Fully block-commented for clarity and future devs

import {
  createPipelineStepSuccess,
} from "../pipeline_step";

import {
  buildScoringShell,
} from "../../builders/scoring_builder";

export const createScoringStep = () => ({
  name:
    "scoring_builder",

  label:
    "Scoring Builder",

  run: async (
    context
  ) => {
    const result =
      await buildScoringShell(
        context
      );

    return createPipelineStepSuccess({
      step:
        "scoring_builder",

      label:
        "Scoring Builder",

      created:
        result?.createdCount ||
        result?.plannedCount ||
        0,

      message:
        result?.message,

      metadata:
        result,

      startedAt:
        context.startedAt,
    });
  },

  afterSuccess: ({
    result,
    sharedContext,
  }) => {
    sharedContext.scoringResult =
      result?.metadata ||
      null;

    sharedContext.scoringFactors =
      result?.metadata?.createdFactors ||
      [];
  },
});